import { Component, Injector, Input, OnInit, Renderer2 } from '@angular/core';
import { AppComponent } from 'src/app/app.component';

declare var $: any;
@Component({
  selector: 'app-store-near-by-stores',
  templateUrl: './store-near-by-stores.component.html',
  styleUrls: ['./store-near-by-stores.component.scss']
})
export class StoreNearByStoresComponent implements OnInit {

  @Input() storDetails: any;

  app: AppComponent;
  renderer: Renderer2;

  constructor(public injector: Injector) {
    this.app = this.injector.get<AppComponent>(AppComponent);
    this.renderer = this.injector.get<Renderer2>(Renderer2);

    if (this.app.isBrowser) {
      window.scrollTo(0, 0);
      this.renderer.addClass(document.body, 'listingPage')
    }

   }

  ngOnInit(): void {
  }

  viewStore(url: string) {
      window.open(url, '_blank');
  }
}
